import { Alert as MuiAlert, Zoom } from "@mui/material";
import React, { Component } from "react";
import InfoIcon from "../resources/icons-info-circle.svg";

export default class Alert extends Component<any> {
  static defaultProps = {
    scrollTo: false,
  };

  ref: any;

  constructor(props: any) {
    super(props);

    this.ref = React.createRef();
  }

  componentDidMount() {
    const { scrollTo }: any = this.props;
    if (scrollTo) this.ref.current.scrollIntoView({ behavior: "smooth" });
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    const { scrollTo }: any = this.props;
    if (scrollTo) this.ref.current.scrollIntoView({ behavior: "smooth" });
  }

  render() {
    const { severity, sx, icon, showIcon = true }: any = this.props;

    return (
      <div ref={this.ref} className="klayo-alert_container">
        <Zoom in={true}>
          <MuiAlert
            {...this.props}
            icon={
              icon ? (
                icon
              ) : severity === "info" && showIcon ? (
                <InfoIcon />
              ) : (
                false
              )
            }
            className="klayo-alert"
            sx={{
              "& .MuiAlert-message": {
                width: "100%",
                fontWeight: 400,
                fontSize: "16px",
              },
              "& a": {
                textDecoration: "none",
                cursor: "pointer",
                fontWeight: 500,
                fontSize: "14px",
              },
              ...sx,
            }}
          />
        </Zoom>
      </div>
    );
  }
}
